import {AuthConfig, OAuthModuleConfig} from 'angular-oauth2-oidc';
import {environment} from "../environments/environment";
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

const getAppId = () => {
    if (Capacitor.getPlatform() === 'android') {
      return environment.appIdAndroid.toLocaleLowerCase() + '://';
    }
    if (Capacitor.getPlatform() === 'ios') {
      return environment.appIdIos.toLocaleLowerCase() + '://';
    }

    return appOrigin + '/index.html';
}

// window.location.origin ritorna "null" per schemi custom (Electron con electron-serve).
// Ricostruiamo l'origin manualmente in quel caso.
const appOrigin = window.location.origin !== 'null'
    ? window.location.origin
    : `${window.location.protocol}//${window.location.host}`;


export const authConfig: AuthConfig = {
    issuer: environment.authenticationUrl,
    customQueryParams: {
        organizationUUID: environment.organizationUUID,
        userType: "ApplicationUser@cataleanUser",
        prompt: "login",
        lang:'' //'en'
    },
    oidc:true,
    requireHttps: environment.production,
    clientId: 'tecnopool-catalean', // The "Auth Code + PKCE" client
    responseType: 'code',
    redirectUri: getAppId(),
    logoutUrl: getAppId(),
    postLogoutRedirectUri: getAppId(),
    scope: 'openid profile email offline_access',
    timeoutFactor: 0.75, // For faster testing
    sessionChecksEnabled: false,
    showDebugInformation: !environment.production,
    clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
    nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by IdentityServer's URI encoding
    openUri: (uri: string) => {
      Capacitor.isNativePlatform() ?  Browser.open({url:uri}): location.href = uri
    }
};

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [environment.productsUrl, environment.structuresUrl, environment.wishlistUrl],
    sendAccessToken: true,
  }
};
